import { render } from "./componentTester.vue?vue&type=template&id=46b92578"
import script from "./componentTester.vue?vue&type=script&lang=js"
export * from "./componentTester.vue?vue&type=script&lang=js"

import "./componentTester.vue?vue&type=style&index=0&id=46b92578&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__